/**
 * OnboardingAdmin — prospect applications pipeline.
 *
 * Covers the full prospect funnel: public signup → admin review →
 * Approve (sends invite + creates airline) or Decline.
 * Terminal state: onboarded (auth user created) or declined.
 *
 * Post-onboarding user lifecycle (revoke / reinstate) lives in UsersAdmin.
 *
 * Permissions: super-admin only.
 */

import ProspectsAdmin from './ProspectsAdmin';

interface OnboardingAdminProps {
  newProspectCount?: number;
}

export default function OnboardingAdmin({ newProspectCount = 0 }: OnboardingAdminProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-steel/20 p-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-navy">Applications</h2>
        <p className="text-sm text-steel mt-0.5">
          Public signup applications — approve to send an invite and create the airline if needed.
        </p>
      </div>
      <ProspectsAdmin newCount={newProspectCount} />
    </div>
  );
}
